<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>计费模型</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!-- 搜索筛选 -->
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="name" label="模型名称" >
      </el-table-column>
      <el-table-column sortable prop="tip_ele_price" label="尖电价(元)">
        <template slot-scope="scope">
          {{ scope.row.tip_ele_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="tip_service_price" label="尖服务费(元)">
        <template slot-scope="scope">
          {{ scope.row.tip_service_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="high_ele_price" label="峰电费(元)">
        <template slot-scope="scope">
          {{ scope.row.high_ele_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="high_service_price" label="峰服务费(元)">
        <template slot-scope="scope">
          {{ scope.row.high_service_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="par_ele_price" label="平电价(元)">
        <template slot-scope="scope">
          {{ scope.row.par_ele_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="par_service_price" label="平服务费(元)">
        <template slot-scope="scope">
          {{ scope.row.par_service_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="valley_ele_price" label="谷电价(元)">
        <template slot-scope="scope">
          {{ scope.row.valley_ele_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="valley_service_price" label="谷服务费(元)">
        <template slot-scope="scope">
          {{ scope.row.valley_service_price/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="status" label="状态">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.status == 1" type="success">有效</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.is_disable ==0 ">无效</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deletePrice(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="模型名称" prop="name">
          <el-input size="small" v-model="editForm.name"  placeholder="请输入模型名称"></el-input>
        </el-form-item>
        <el-form-item label="尖电价(分)" prop="tip_ele_price">
          <el-input size="small" v-model="editForm.tip_ele_price"  placeholder="请输入尖电价"></el-input>
        </el-form-item>
        <el-form-item label="尖服务费(分)" prop="tip_service_price">
          <el-input size="small" v-model="editForm.tip_service_price"  placeholder="请输入尖服务费"></el-input>
        </el-form-item>
        <el-form-item label="峰电费(分)" prop="high_ele_price">
          <el-input size="small" v-model="editForm.high_ele_price"  placeholder="请输入峰电费"></el-input>
        </el-form-item>
        <el-form-item label="峰服务费(分)" prop="high_service_price">
          <el-input size="small" v-model="editForm.high_service_price"  placeholder="请输入峰服务费"></el-input>
        </el-form-item>
        <el-form-item label="平电价(分)" prop="par_ele_price">
          <el-input size="small" v-model="editForm.par_ele_price"  placeholder="请输入平电价"></el-input>
        </el-form-item>
        <el-form-item label="平服务费(分)" prop="par_service_price">
          <el-input size="small" v-model="editForm.par_service_price"  placeholder="请输入平服务费"></el-input>
        </el-form-item>
        <el-form-item label="谷电价(分)" prop="valley_ele_price">
          <el-input size="small" v-model="editForm.valley_ele_price"  placeholder="请输入谷电价"></el-input>
        </el-form-item>
        <el-form-item label="谷服务费(分)" prop="valley_service_price">
          <el-input size="small" v-model="editForm.valley_service_price"  placeholder="请输入谷服务费"></el-input>
        </el-form-item>
        <el-form-item label="电价设置" >
          <el-button type="primary" size="mini" @click="handleAdd">添加</el-button>
        </el-form-item>


        <el-form-item v-for="(info,index) in editForm.price_infos" :key="info.id" class="price_info">
      <!--第0个就是我们初始的明细输入，需要判断不为0再显示明细的index-->
            <el-form-item
                style="margin-left: 0px;"
                label="开始时间"
                :prop="'price_infos.'+index+'.open_start_time'"
            >
              <el-time-select
                  disabled
                  v-model="info.open_start_time"
                  :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '23:59'
                  }"
                  placeholder="选择时间">
                </el-time-select>
            </el-form-item>
            <el-form-item
                label="结束时间"
                :prop="'price_infos.'+index+'.open_end_time'"

            >
              <el-time-select
                  v-model="info.open_end_time"
                  :picker-options="{
                    start: info.open_start_time,
                    step: '00:30',
                    end: '23:59'
                  }"
                   @change="handelChange(info)"
                  placeholder="选择时间">
                </el-time-select>
            </el-form-item>
            <el-form-item
                label="选择价格类别"
                :prop="'price_infos.' + index + '.price_type'"
            >
              <el-select v-model="info.price_type" placeholder="请选择场地名称" clearable>
                <el-option v-for="item in price_types" :label="item.name" :value="item.val" :key="item.val"></el-option>
              </el-select>

            </el-form-item>
            <el-form-item label=" " >
              <el-button v-if="index!=0" @click.prevent="remove(info)" size="mini" >删除</el-button>
            </el-form-item>
            <hr/>
          </el-form-item>
          <el-form-item label="剩余时段价格">
              <el-select v-model="editForm.other_price_type" placeholder="剩余时段价格类别" clearable>
                <el-option v-for="item in price_types" :label="item.name" :value="item.val" :key="item.val"></el-option>
              </el-select>
          </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getPrice,get_suppliers_name,addPrice,updatePrice,deletePrice  } from '../../api/price'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      price_types:[
        {"name":"尖电价",val:1}, {"name":"峰电价",val:2}, {"name":"平电价",val:3}, {"name":"谷电价",val:4}
      ],
      priceList:[],
      suppliers_names:[],
      pcaTextArr,
      selectedOptions: [],
      station_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        name: '',
        tip_ele_price: '',
        tip_service_price: '',
        high_ele_price: '',
        high_service_price: '',
        par_ele_price: '',
        par_service_price: '',
        valley_ele_price: '',
        valley_service_price: '',
        status: 1,
        other_price_type:1,
        price_infos:[{'open_start_time':'00:00','open_end_time':'23:59','price_type':1}]
      },
      status_names:[{name:'启用',val:1},{name:'停用',val:0}],
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请名称', trigger: 'blur' }
        ],
        tip_ele_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        tip_service_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        high_ele_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        high_service_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        par_ele_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        par_service_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        valley_ele_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        valley_service_price: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        station_name: '',
        is_fix: '',
        serial_number:'',
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.get_suppliers_name()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handelChange(item) {
      let size = this.editForm.price_infos.length
      var index = this.editForm.price_infos.indexOf(item)

      if (index+1 !== size) {
        this.editForm.price_infos[index+1].open_start_time = item.open_end_time
      }
      console.log( this.editForm.price_infos)
    },
    remove(item) {
      var index = this.editForm.price_infos.indexOf(item)
      if (index !== -1) {
        this.editForm.price_infos.splice(index, 1)
      }
    },
    handleAdd(){
        //最后一条
        let size = this.editForm.price_infos.length
        this.editForm.price_infos.push({'open_start_time':this.editForm.price_infos[size-1].open_end_time,'open_end_time':'23:59','price_type':1});
    },
    handleAdd(){
        //最后一条
        let size = this.editForm.price_infos.length
        this.editForm.price_infos.push({'open_start_time':this.editForm.price_infos[size-1].open_end_time,'open_end_time':'23:59','price_type':1});
    },
    get_suppliers_name(){
      get_suppliers_name().then(res => {
        if (res.code == 0) {
            this.suppliers_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },

    // 获取公司列表
    getdata() {
      this.loading = true
      getPrice(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.name = row.name
        this.editForm.tip_ele_price = row.tip_ele_price
        this.editForm.tip_service_price = row.tip_service_price
        this.editForm.high_ele_price = row.high_ele_price
        this.editForm.high_service_price = row.high_service_price
        this.editForm.par_ele_price = row.par_ele_price
        this.editForm.par_service_price = row.par_service_price
        this.editForm.valley_ele_price = row.valley_ele_price
        this.editForm.valley_service_price = row.valley_service_price
        this.editForm.status = row.status
        this.editForm.id = row.id
        this.editForm.price_infos = row.price_info
      } else {
        this.title = '添加'
        this.editForm =  {
          name: '',
        tip_ele_price: '',
        tip_service_price: '',
        high_ele_price: '',
        high_service_price: '',
        par_ele_price: '',
        par_service_price: '',
        valley_ele_price: '',
        valley_service_price: '',
        status: 1,
        price_infos:[{'open_start_time':'00:00','open_end_time':'23:59','price_type':1}]
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.price_infos[this.editForm.price_infos.length-1].open_end_time !='23:59' && this.editForm.price_infos[this.editForm.price_infos.length-1].open_end_time !='23:59:00'){
            this.editForm.price_infos.push({'open_start_time':this.editForm.price_infos[this.editForm.price_infos.length-1].open_end_time,'open_end_time':'23:59','price_type':this.editForm.other_price_type})
          }
          this.editForm.price_info = JSON.stringify(this.editForm.price_infos)
          console.log(this.editForm.price_info)
          if(this.editForm.id){
            updatePrice(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            console.log(this.editForm)
            addPrice(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deletePrice(index, row) {
      this.$confirm('此操作将删除该场地, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deletePrice(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.price_info >>> .el-form-item__content{
  margin-left: 0px!important;
}
</style>




// WEBPACK FOOTER //
// src/views/price/Price.vue